import React from 'react'
import SubjectBadge from '@components/SubjectBadge'

const ItemSubjects = ({subjects}) => {
    if (subjects === null || subjects.length === 0) return null
    return (
      <div>
      <p className="h6 font-weight-bold">Subjects</p> 
      <p>
          {subjects.items.map((item) => {
            return <SubjectBadge subject={item} key={item.subject.uid}/>
          })} 
      </p>
      <hr/>
      </div>
    )
  }

export default ItemSubjects;